// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-to-delete {
  font-weight: bold;
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/app/components/confirm-window/confirm-window.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,UAAA;AACF","sourcesContent":[".file-to-delete {\n  font-weight: bold;\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
